import {has} from "lodash"

export function getContentPositionStyle(bodyRef, field, scaleInfo, totalPage) {
    const SPACING = 10
    const bodyWidth = bodyRef?.current.offsetWidth
    const bodyHeight = bodyRef?.current.offsetHeight
    const canShowLeft = bodyWidth + SPACING < field.placeInformation.left
    const canShowRight =
        field.placeInformation.left + field.placeInformation.width + bodyWidth + SPACING < scaleInfo.pageWidth
    const canShowTop = bodyHeight + SPACING < field.placeInformation.top
    const canShowBottom =
        field.placeInformation.top + field.placeInformation.height + bodyHeight + SPACING <
        scaleInfo.pageHeight * totalPage
    let style: any = {}
    if (canShowRight) {
        style.left = field.placeInformation.width + SPACING
        if (canShowBottom) {
            style.top = 0
        } else if (canShowTop) {
            style.top = -(bodyHeight + SPACING)
        }
    } else if (canShowLeft) {
        style.left = -(bodyWidth + SPACING)
        if (canShowBottom) {
            style.top = 0
        } else if (canShowTop) {
            style.top = -(bodyHeight + SPACING)
        }
    } else {
        style.left = 0
    }
    if (!has(style, "top")) {
        if (canShowBottom) {
            style.top = field.placeInformation.height + SPACING
        } else if (canShowTop) {
            style.top = -(bodyHeight + SPACING)
        } else {
            style.top = 0
        }
    }
    return style
}
